import { LabelCoveragePriority } from "src/store/api/generatedApi";

export type BaseStrategy = "breadth" | "depth";

export const decomposePriority = (
  priority: LabelCoveragePriority
): {
  labelRecent: boolean;
  baseStrategy: BaseStrategy;
} => {
  switch (priority) {
    case "recent_breadth":
    case "last_calendar_day_then_breadth":
      return { labelRecent: true, baseStrategy: "breadth" };
    case "recent_depth":
    case "last_calendar_day_then_depth":
      return { labelRecent: true, baseStrategy: "depth" };
    case "breadth":
      return { labelRecent: false, baseStrategy: "breadth" };
    case "depth":
      return { labelRecent: false, baseStrategy: "depth" };
  }
};

export const composePriority = (
  labelRecent: boolean,
  baseStrategy: BaseStrategy
): LabelCoveragePriority => {
  if (labelRecent) {
    return baseStrategy === "breadth" ? "recent_breadth" : "recent_depth";
  }
  return baseStrategy;
};
